<template>
	<section class="provider-configuration-page">
		<header class="configuration-heading">
			<div>
				<h2>配置管理</h2>
				<p>为已发布的虚拟商品配置功能权益，下单后将按配置生成订单权益</p>
			</div>
			<el-button type="primary" icon="el-icon-plus" @click="handleCreate">新增配置</el-button>
		</header>

		<div class="configuration-overview">
			<div class="overview-icon"><i class="el-icon-setting"></i></div>
			<div>
				<strong>商品权益配置</strong>
				<p>权益支持按次数或有效期计量，每个商品可组合配置多项功能权益。</p>
			</div>
			<span>已配置 {{ configuredCount }} 个商品</span>
		</div>

		<div class="configuration-table-card">
			<div class="table-card-heading">
				<div>
					<strong>配置信息列表</strong>
					<span>查看商品当前关联的权益清单</span>
				</div>
			</div>

			<el-table
				v-loading="loading"
				:data="configurationList"
				border
				element-loading-text="正在加载商品权益配置..."
				empty-text="暂无商品权益配置"
			>
				<el-table-column label="商品名称" min-width="260">
					<template slot-scope="{ row }">
						<div class="product-name-cell">
							<span class="product-icon"><i class="el-icon-goods"></i></span>
							<strong>{{ row.goodsName }}</strong>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="售价" width="145" align="center">
					<template slot-scope="{ row }">
						<span class="price-text">¥{{ formatPrice(row.price) }}</span>
						/件
					</template>
				</el-table-column>
				<el-table-column label="功能权益" width="130" align="center">
					<template slot-scope="{ row }">
						<strong class="benefit-count">{{ row.benefits.length }}</strong>
						项
					</template>
				</el-table-column>
				<el-table-column label="权益清单预览" min-width="360">
					<template slot-scope="{ row }">
						<div class="benefit-preview">
							<el-tag v-for="item in row.benefits.slice(0, 3)" :key="item.id" size="small" effect="plain">
								{{ item.name }} · {{ item.quota }}{{ item.unit }}
							</el-tag>
							<span v-if="row.benefits.length > 3" class="more-benefits">+{{ row.benefits.length - 3 }} 项</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120" align="center">
					<template slot-scope="{ row }">
						<el-button type="primary" plain size="small" icon="el-icon-edit-outline" @click="handleConfigure(row)">
							配置
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</section>
</template>

<script>
	import { queryMyPublishedGoodsBenefitPage } from '@/api/mall'

	export default {
		name: 'ProviderConfiguration',
		data() {
			return {
				loading: false,
				configurationList: []
			}
		},
		computed: {
			configuredCount() {
				return this.configurationList.filter(item => item.benefits.length > 0).length
			}
		},
		created() {
			this.loadData()
		},
		methods: {
			// 查询当前用户已上架商品，商品未绑定权益时清单默认为空。
			async loadData() {
				this.loading = true
				try {
					const response = await queryMyPublishedGoodsBenefitPage({ page: 1, size: 1000 })
					const data = response.data || {}
					const records = data.records || data.list || []
					this.configurationList = records.map(this.mapConfigurationRecord)
				} finally {
					this.loading = false
				}
			},
			mapConfigurationRecord(goods) {
				return {
					id: goods.id,
					productId: goods.id,
					goodsName: goods.goodsTitle || '-',
					goodsCode: goods.orderCode || goods.id,
					price: goods.sellingPrice,
					rowState: goods.rowState,
					benefits: (goods.goodsBenefits || []).map(this.mapBenefit)
				}
			},
			mapBenefit(item) {
				return {
					id: item.benefitTemplateId || item.id,
					linkId: item.id,
					name: item.memberBenefitName,
					description: item.benefitDescription,
					measureType: item.measureType === 'PERIOD' ? 'TIME' : 'COUNT',
					quota: item.benefitQuota,
					unit: item.benefitUnit
				}
			},
			formatPrice(price) {
				return Number(price || 0).toFixed(2)
			},
			handleCreate() {
				this.$router.push('/provider/configuration/edit')
			},
			handleConfigure(row) {
				this.$router.push({ path: '/provider/configuration/edit', query: { id: row.id } })
			}
		}
	}
</script>

<style lang="scss" scoped>
	.provider-configuration-page {
		min-height: 100%;
		padding: 24px;
		overflow: hidden;
		border: 1px solid #e4e9ef;
		border-radius: 8px;
		background: #fff;
		box-sizing: border-box;
	}
	.configuration-heading {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-bottom: 19px;
		border-bottom: 1px solid #e9edf2;
		h2 {
			margin: 0 0 7px;
			color: #303846;
			font-size: 21px;
		}
		p {
			margin: 0;
			color: #7d8795;
			font-size: 14px;
		}
	}
	.configuration-overview {
		display: flex;
		align-items: center;
		margin-top: 18px;
		padding: 18px 20px;
		overflow: hidden;
		border: 1px solid #d7e7f8;
		border-radius: 8px;
		background: linear-gradient(110deg, #eff7ff, #f8fbff 65%, #eef8f6);
		.overview-icon {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 46px;
			height: 46px;
			margin-right: 14px;
			border-radius: 10px;
			color: #fff;
			font-size: 22px;
			background: linear-gradient(135deg, #3185dd, #1d67bc);
		}
		strong {
			color: #314257;
			font-size: 16px;
		}
		p {
			margin: 5px 0 0;
			color: #77869a;
			font-size: 14px;
		}
		> span {
			margin-left: auto;
			padding: 7px 13px;
			border-radius: 15px;
			color: #2871be;
			font-size: 14px;
			background: #fff;
		}
	}
	.configuration-table-card {
		margin-top: 18px;
		overflow: hidden;
		border: 1px solid #e3e8ee;
		border-radius: 8px;
	}
	.table-card-heading {
		display: flex;
		align-items: center;
		min-height: 65px;
		padding: 0 18px;
		background: #fbfcfd;
		strong {
			color: #303b4d;
			font-size: 17px;
		}
		span {
			margin-left: 12px;
			color: #8c96a4;
			font-size: 14px;
		}
	}
	.product-name-cell {
		display: flex;
		align-items: center;
		.product-icon {
			display: flex;
			align-items: center;
			justify-content: center;
			flex: 0 0 38px;
			height: 38px;
			margin-right: 11px;
			border-radius: 7px;
			color: #347ed0;
			font-size: 19px;
			background: #edf5ff;
		}
		strong {
			color: #3d4857;
			font-size: 14px;
			line-height: 22px;
		}
	}
	.price-text {
		margin-right: 2px;
		color: #e46b30;
		font-size: 16px;
		font-weight: 600;
	}
	.benefit-count {
		color: #2874c7;
		font-size: 18px;
	}
	.benefit-preview {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 7px;
		.el-tag {
			max-width: 220px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}
	.more-benefits {
		color: #798696;
		font-size: 14px;
	}
	::v-deep .el-table {
		color: #566170;
		font-size: 14px;
	}
	::v-deep .el-table th {
		color: #435166;
		background: #f5f8fb;
	}
</style>
